<!-- 该组件基于vue-countTo组件 -->
<template>
  <div
    class="count-to"
    :class="{ 'no-bg-style': noBgStyle }"
    @click="handleClick"
  >
    <div class="count-to-container" v-if="multi">
      <div class="octagon multi" v-for="(num, index) in splitCur" :key="index">
        <div class="_octagon">
          <i class="iconfont" :class="[`icon-number-${num}`]"></i>
        </div>
      </div>
    </div>
    <div class="count-to-container" v-else>
      <div class="octagon single">
        <div class="_octagon">
          <i
            v-for="(num, index) in splitCur"
            :style="{ fontSize: iSize + 'px' }"
            class="iconfont"
            :class="[`icon-number-${num}`]"
            :key="index"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {
//   requestAnimationFrame,
//   cancelAnimationFrame,
// } from "@/assets/js/requestAnimationFrame";
export default {
  props: {
    startVal: {
      type: Number,
      required: false,
      default: 0,
    },
    endVal: {
      type: Number,
      required: false,
      default: 2017,
    },
    duration: {
      type: Number,
      required: false,
      default: 3000,
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true,
    },
    decimals: {
      type: Number,
      required: false,
      default: 0,
      validator(value) {
        return value >= 0;
      },
    },
    decimal: {
      type: String,
      required: false,
      default: ".",
    },
    separator: {
      type: String,
      required: false,
      default: "",
    },
    prefix: {
      type: String,
      required: false,
      default: "",
    },
    suffix: {
      type: String,
      required: false,
      default: "",
    },
    useEasing: {
      type: Boolean,
      required: false,
      default: true,
    },
    easingFn: {
      type: Function,
      default(t, b, c, d) {
        return (c * (-Math.pow(2, (-10 * t) / d) + 1) * 1024) / 1023 + b;
      },
    },
    multiLen: {
      type: Number,
      default: 5,
    },
    noBgStyle: {
      type: Boolean,
      default: false,
    },
    iSize: {
      type: Number,
      default: 28,
    },
  },
  data() {
    return {
      localStartVal: this.startVal,
      displayValue: this.formatNumber(this.startVal),
      printVal: null,
      paused: false,
      localDuration: this.duration,
      startTime: null,
      timestamp: null,
      remaining: null,
      rAF: null,
      multi: this.checkMulti(),
    };
  },
  computed: {
    countDown() {
      return this.startVal > this.endVal;
    },
    splitCur() {
      // console.log(this.displayValue);
      return this.displayValue.split("");
    },
  },
  watch: {
    startVal() {
      if (this.autoplay) {
        this.start();
      }
    },
    endVal() {
      if (this.autoplay) {
        this.start();
        this.multi = this.checkMulti();
      }
    },
  },
  mounted() {
    if (this.autoplay) {
      this.start();
    }
    this.$emit("mountedCallback");
  },
  methods: {
    handleClick() {
      this.$emit("handleClick");
    },
    start() {
      this.localStartVal = this.startVal;
      this.startTime = null;
      this.localDuration = this.duration;
      this.paused = false;
      this.rAF = requestAnimationFrame(this.count);
    },
    pauseResume() {
      if (this.paused) {
        this.resume();
        this.paused = false;
      } else {
        this.pause();
        this.paused = true;
      }
    },
    pause() {
      cancelAnimationFrame(this.rAF);
    },
    resume() {
      this.startTime = null;
      this.localDuration = +this.remaining;
      this.localStartVal = +this.printVal;
      requestAnimationFrame(this.count);
    },
    reset() {
      this.startTime = null;
      cancelAnimationFrame(this.rAF);
      this.displayValue = this.formatNumber(this.startVal);
    },
    count(timestamp) {
      if (!this.startTime) this.startTime = timestamp;
      this.timestamp = timestamp;
      const progress = timestamp - this.startTime;
      this.remaining = this.localDuration - progress;
      if (this.useEasing) {
        if (this.countDown) {
          this.printVal =
            this.localStartVal -
            this.easingFn(
              progress,
              0,
              this.localStartVal - this.endVal,
              this.localDuration
            );
        } else {
          this.printVal = this.easingFn(
            progress,
            this.localStartVal,
            this.endVal - this.localStartVal,
            this.localDuration
          );
        }
      } else {
        if (this.countDown) {
          this.printVal =
            this.localStartVal -
            (this.localStartVal - this.endVal) *
              (progress / this.localDuration);
        } else {
          this.printVal =
            this.localStartVal +
            (this.endVal - this.localStartVal) *
              (progress / this.localDuration);
        }
      }
      if (this.countDown) {
        this.printVal =
          this.printVal < this.endVal ? this.endVal : this.printVal;
      } else {
        this.printVal =
          this.printVal > this.endVal ? this.endVal : this.printVal;
      }
      this.displayValue = this.formatNumber(this.printVal);
      if (progress < this.localDuration) {
        this.rAF = requestAnimationFrame(this.count);
      } else {
        this.$emit("callback");
      }
    },
    isNumber(val) {
      return !isNaN(parseFloat(val));
    },
    formatNumber(num) {
      num = num.toFixed(this.decimals);
      num += "";
      const x = num.split(".");
      let x1 = x[0];
      const x2 = x.length > 1 ? this.decimal + x[1] : "";
      const rgx = /(\d+)(\d{3})/;
      if (this.separator && !this.isNumber(this.separator)) {
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, "$1" + this.separator + "$2");
        }
      }
      return this.prefix + x1 + x2 + this.suffix;
    },
    // 检查显示方式
    checkMulti() {
      return String(this.endVal).length < this.multiLen;
    },
  },
  destroyed() {
    cancelAnimationFrame(this.rAF);
  },
};
</script>

<style scoped lang="scss">
.count-to {
  .count-to-container {
    display: flex;
    /*font-size: 0;*/
  }

  .octagon {
    width: 213px;
    height: 30px;
    padding: 0 2px;
    position: relative;
    z-index: 22;
    box-sizing: border-box;
    /*display: inline-block;*/

    &.multi {
      width: 25px;
    }

    + .octagon {
      margin-left: 3px;
    }

    &:before,
    &:after {
      content: "";
      z-index: -1;
      position: absolute;
      top: 0;
      bottom: 0;
      height: 100%;
      // chrome 73.0.3683.103 正式版（64位） 会出现左图1个像素的偏差
      background-size: 19px 100% !important;
      width: 18px;
    }

    //&:before {
    //  left: 5px;
    //  background: url("~@/assets/images/bs/tra-num-left-bg.png") no-repeat;
    //}
    //
    //&:after {
    //  right: 5px;
    //  background: url("~@/assets/images/bs/tra-num-right-bg.png") no-repeat;
    //}

    ._octagon {
      height: 100%;
      background: url("~@/assets/images/bs/num-bg.png") repeat-x;
      background-size: 100% 100%;
      text-align: center;
      position: relative;

      .iconfont {
        font-size: 16px;
        position: absolute;
        display: inline-block;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #feeb48;
        margin: 0;
      }
    }

    &.single {
      ._octagon {
        line-height: 69px;
        .iconfont {
          position: static;
          transform: none;
          margin: 0;
          font-size: 28px;
        }
      }
    }
    .icon-number-d {
      font-size: 12px !important;
      transform: scale(0.5) !important;
      vertical-align: -4px;
    }
    .icon-number-1 {
      width: 20px;
    }
  }
  &.no-bg-style {
    .octagon {
      &:before,
      &:after {
        background: none;
      }
      ._octagon {
        background: none;
      }
    }
  }
}
</style>
